var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('client-trajectory-enrolments-table',_vm._b({attrs:{"columns":_vm.columns,"filterable":_vm.filterable}},'client-trajectory-enrolments-table',_vm.$attrs,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }